const SurveyModule = () => import('./SurveyModule.vue')
const SurveyIndex = () => import('./views/SurveyIndex.vue')

export const surveyRoute = {
  path: '/survey',
  name: 'survey',
  component: SurveyModule,
  meta: {
    title: 'Survey',
    requiresAuth: true,
    keepAlive: true,
  },
  children: [
    {
      path: '',
      name: 'survey-index',
      component: SurveyIndex,
      // meta: {
      //   permission: 'survey.view',
      // },
      // beforeEnter: checkPermission('survey.view'),
    },
  ],
}
